import styled from 'styled-components'
import DownArrow from "web/assets/images/arrow_bottom_down_downward_navigation_icon.png";

const SelectWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    select, input {
        background-color: #ffffff;
        padding: 5px;
        border: solid 1px #97979729 !important;
        border-radius: 3px;
        margin: 2px 0;
        font-size: 14px;
        height: 32px;
    };
    label {
        background-color: #ffffff;
        padding: 5px;
        margin: 2px 0;
        font-size: 14px;
    }
    button{
      background: #61b01f;
      min-height: 40px;
      background: linear-gradient(to bottom, #61b01f 0%,#27911b 100%);
      color: white;
      white-space: nowrap;
      border: 0;
      border-radius: 5px;
      padding: 5px 15px;
      margin: 2px;
      cursor: pointer
    }
    @media screen and (max-width:465px){
      justify-content: flex-start;
      label{
        marging: 0;
        padding:0;
      }
    }
`
const InnerHeader = styled.div`
    min-height: 50px;
    display: flex;
    padding: 20px 10px;
    align-items: flex-start;
    border-bottom: solid 1px #97979729;
    gap: 10px;
    flex-wrap: wrap;
    .search-input-wrapper{
      display: flex;
      flex-grow: 1;
      justify-content: end;
    }
    @media screen and (max-width:465px){
        display: block;
        width: 100%;
        .search-input-wrapper{
          justify-content: flex-start;
          width: 100%;
        }
    }
`
const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  border-radius: 4.2px;
  overflow: auto;
  max-width: 260px;
  min-width: 200px;
  width: 100%;
  justify-content: end;
  margin: 3px;
  input {
    background: #ffffff;
    border: 1px solid #87cdf1;
    padding: 4px 35px 4px 15px;
    width: 100%;
    border-radius: 4px;
    height: 40px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #00000087;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #00000087;
    }
    ::placeholder {
      color: #00000087;
    }
  }
  svg {
    position: absolute;
    right: 12px;
    top: 12px;
    color: #525e66;
    font-size:20px
  }
`;

const SelectWrapperMulti = styled.div`
  display: flex;
  justify-content: flex-end;
  .custom-date-piker{
    margin-top: 2px;
    max-width: 200px !important;
  }
  .css-yk16xz-control:hover{
    border: 1px solid #87cdf1;
  }
  select,
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 7px 13px 7px 10px;
    border-radius: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  select {
    background-image: url(${DownArrow});
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) 50%;
    padding: 8px 25px 10px 13px;
    border: 1px solid #87cdf1 !important;
  }
  .fQtZNt select, .fQtZNt input{
    border: 1px solid #87cdf1 !important;
    padding: 6px 25px 10px 13px !important;
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 16px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-color: none;
  }
  .basic-multi-select {
    margin: 2px 0;
  }
  .select__value-container {
    max-height: 78.38px;
    overflow: auto;
      input {
        padding: 7px 0;
        min-width: auto;
      }
  }
  .select__control {
    border: 1px solid #87cdf1;
  }
  .react-select-2-input {
    padding: 5px 0;
  }
  .file-input-wrapper .MuiFormControl-root{
    height: 40px;
  }
  .file-input-wrapper .MuiFormControl-root .MuiInput-root{
    padding: 0px 10px;
  }
  @media screen and (max-width:465px){
    justify-content: flex-start;
    margin: 10px 0;
    label{
      min-width: 110px;
    }
  }
`;

const AdjInvoiceTableContainer = styled.div`
  overflow-y: auto;
  table {
    thead {
      border-bottom: 1px solid #ececee;
      tr {
        background:  #FCFCFC;
        border:1px solid #ececee;
        th {
          padding-block: 20px;
          color: #000000;
          font-size: 16px;
          font-family: "latosemibold";
          // padding-inline: 20px;
          white-space: nowrap;
          border:none;        
          
        }
      }
    }
    tbody {
      border: 1px solid #ececee;
      .even-rows{
        background: #FCFCFC;
      }
      .odd-rows{
        background: #fff;
      }
      .set-border{
        border: 1px solid #ececee;
        border-bottom: 0;
      }
      tr {
        border: none;
        td {
          padding: 16px;
          font-size: 14px;
          font-family: "latoregular";
          border: 0;

          /* :first-child {
            font-family: "latosemibold";
          } */
        }
      }
    }
  }
    
`;
const PaidDateModal = styled.div`
    .file-input-wrapper{
      width: 200px !important;
    }
    p{
      font-weight: bold;
      font-size: 20px;
    } 
    .buttonStyle{
      background: #61ae24;
      border: none;
      border-radius: 5px;
      width: 75px;
      padding: 8px;

    }
    .cancel-button{
      background: #cccbcb;
      border: none;
      border-radius: 5px;
      margin-right: 10px;
      width: 75px;
      padding: 8px;
    }
`
export { SelectWrapper, InnerHeader, SearchWrapper, SelectWrapperMulti, AdjInvoiceTableContainer, PaidDateModal};